// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import UUID from 'vue-uuid';
import { sync } from 'vuex-router-sync';
import App from './App';
import i18n from './i18n';
import router from './router';
import store from './store';
import EdocUi from 'edoc-ui';
import UnsupportedBrowser from './plugins/UnsupportedBrowser';
import stonly from './plugins/stonly';
import 'babel-polyfill';

Vue.use(EdocUi);
Vue.use(UUID);
Vue.use(UnsupportedBrowser);
Vue.use(stonly, process.env.STONLY);
require('edoc-ui/lib/edoc-ui.css');
require('@/assets/scss/main.scss');

sync(store, router);

Vue.config.productionTip = false;

store.dispatch('auth/check');

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App),
});

export default { app, router };



// WEBPACK FOOTER //
// ./src/main.js